<script setup>
import { computed, defineProps } from "vue";

const props = defineProps({
  size: { type: String, default: "1x" },
});

const sizeClass = computed(() => `fa-${props.size}`);
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    class="svg-inline--fa"
    :class="sizeClass"
    aria-hidden="true"
    focusable="false"
    style="height: 1.3em; width: 1.3em; vertical-align: -0.2em"
  >
    <g
      fill="none"
      stroke="currentColor"
      stroke-width="38"
      stroke-linejoin="round"
      stroke-linecap="round"
    >
      <path d="M256 40 464 148 256 256 48 148Z" />
      <path d="M464 148v216L256 472 48 364V148" />
      <path d="M256 256v216" />
    </g>
  </svg>
</template>
